<template>
    <app-layout title="Gefaalde e-mails">
        <template #header>
            <page-title title="Gefaalde e-mails" />
        </template>

        <template #pageContent>
            <TableSearch tableId="overview-failed-emails" :values="failedEmails" class="w-1/4" placeholder="Zoeken"/>

            <Table id="overview-failed-emails" :values="failedEmails" class="mt-4 w-4/6">
                <thead>
                    <tr>
                        <Th :sort="false">Referentie</Th>
                        <Th id="mail_to">E-mail</Th>
                        <Th id="subject">Onderwerp</Th>
                        <Th id="created_at">Datum gefaald</Th>
                        <Th :sort="false"></Th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(failedEmail, key) in state.sortedValues['overview-failed-emails']" :key="key">
                        <Td>
                            <Link
                                :href="route('requests.detail',  {'id': failedEmail.request.id })"
                                v-if="failedEmail.request"
                            >
                                {{ failedEmail.request.reference }}
                            </Link>
                            <template v-else>
                                {{ failedEmail.reference }}
                            </template>
                        </Td>
                        <Td>{{ failedEmail.mail_to }}</Td>
                        <Td>{{ failedEmail.subject }}</Td>
                        <Td>
                            <template v-if="failedEmail.created_at">
                                {{ moment(failedEmail.created_at).format('DD/MM/YYYY HH:mm') }}
                            </template>
                        </Td>
                        <Td>
                            <Button
                                text="Opnieuw verzenden"
                                size="small"
                                buttonClass="redo"
                                @click="resendEmail(failedEmail)"
                                :loading="resendingEmail[failedEmail.id]"
                            />
                            <Button
                                size="small"
                                title="Bewerken"
                                buttonClass="edit"
                                @click="editResendEmail(failedEmail)"
                            />
                            <Button
                                size="small"
                                title="Verwijderen"
                                buttonClass="delete"
                                @click="deleteResendEmail(failedEmail)"
                            />
                        </Td>
                    </tr>
                </tbody>
            </Table>
            <Modal
                visible="hidden"
                ref="modalEditResendEmail"
            >
                <Form @submitted="postEditResendEmail">
                    <Input
                        type="email"
                        label="E-mail"
                        name="mail_to"
                        :required="true"
                        v-model="formEditResendEmail.mail_to"
                        :error="formEditResendEmail.errors.mail_to"
                        layout="vertical"
                    />
                    <Input
                        type="text"
                        label="Onderwerp"
                        name="subject"
                        :required="true"
                        v-model="formEditResendEmail.subject"
                        :error="formEditResendEmail.errors.subject"
                        layout="vertical"
                    />
                    <Button
                        text="Opslaan"
                        buttonClass="save"
                        type="submit"
                        :loading="formEditResendEmail.processing"
                        class="self-end"
                    />
                </Form>
            </Modal>
        </template>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import PageTitle from '@/Components/PageTitle.vue'
import Table from '@/Components/Table.vue'
import Th from '@/Components/Th.vue'
import Td from '@/Components/Td.vue'
import Button from '@/Components/Button.vue'
import TableSearch from '@/Components/TableSearch.vue'
import Modal from '@/Components/Modal.vue'
import Form from '@/Components/Form.vue'
import Input from '@/Components/Input.vue'

import store from '@/store'
import moment from "moment"
import {Link, useForm} from '@inertiajs/inertia-vue3'
import {Inertia} from "@inertiajs/inertia";
import {ref} from "vue";

export default {
    components: {
        AppLayout,
        PageTitle,
        Button,
        Table,
        Td,
        Th,
        TableSearch,
        Modal,
        Link,
        Form,
        Input,
    },
    props: [
        'failedEmails',
    ],
    setup (props){
        let resendingEmail = ref([])
        let modalEditResendEmail = ref(null)
        let formEditResendEmail = []

        props.failedEmails.forEach(function(failedEmail) {
            resendingEmail.value[failedEmail.id] = false
        })

        //To edit failed emails
        formEditResendEmail = useForm({
            id: null,
            mail_to:  null,
            subject: null,
        })

        function resendEmail(failedEmail)
        {
            resendingEmail.value[failedEmail.id] = true

            Inertia.post('/requests/' + failedEmail.id + '/resend-mail', {
                onSuccess: () => {
                    resendingEmail.value[failedEmail.id].value = false
                }
            })
        }

        function editResendEmail(failedEmail)
        {
            formEditResendEmail.id = failedEmail.id
            formEditResendEmail.mail_to = failedEmail.mail_to
            formEditResendEmail.subject = failedEmail.subject

            modalEditResendEmail.value.show = true
        }

        function postEditResendEmail()
        {
            formEditResendEmail.put('/requests/failed-emails/' + formEditResendEmail.id, {
                onSuccess: () => {
                    modalEditResendEmail.value.show = false
                    form.clearErrors()
                    form.reset()
                }
            })
        }

        function deleteResendEmail(failedEmail)
        {
            if (!confirm('Bent u zeker dat u deze e-mail wil verwijderen zonder deze te verzenden?'))
                return

            Inertia.delete('/requests/failed-emails/' + failedEmail.id)
        }

        return {
            state: store.state,
            ...store,
            resendEmail,
            resendingEmail,
            modalEditResendEmail,
            formEditResendEmail,
            editResendEmail,
            postEditResendEmail,
            deleteResendEmail,
        }
    },
    created: function () {
        this.moment = moment;
    },
}

</script>
